import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Radio from "@mui/material/Radio";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { unicodeToString, shuffle } from "../../../Js/Common";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";
import StatusIndicator from "../../../Components/Card/AssetUI/StatusIndicator";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const SF = (props) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const dispatch = useDispatch();

  // State
  const [userAnswer, setUserAnswer] = useState([]);
  const [words, setWords] = useState([]);
  const [logObj, setLogObj] = useState(initLogObj);
  const [received, setReceived] = useState([]);
  const [currentOptionIndex, setCurrentOptionIndex] = useState(0);
  const [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (props.content) {
      setUserAnswer(
        new Array(props.content.epage.options.content.length).fill([])
      );
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData(
          new Array(props.content.epage.options.content.length).fill([])
        )
      );
      let actualAnswer = props.content.epage.options.content.map((val) => {
        return val.text;
      });
      dispatch(currentAssetSliceActions.setCurrentAttemptData(null));

      let allWords = props.content.epage.options.source.words.concat(
        props.content.epage.options.source.distractors
      );

      allWords = allWords.map((word) => {
        return unicodeToString(word);
      });

      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswer,
      });

      setWords(shuffle(allWords));
      setReceived([]);
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    setCurrentOptionIndex(0);
  }, [logObj]);

  useEffect(() => {
    setUserAnswer(
      new Array(props.content.epage.options.content.length).fill([])
    );
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(
      currentAssetSliceActions.setCurrentAttemptData(
        new Array(props.content.epage.options.content.length).fill([])
      )
    );
    setCurrentOptionIndex(0);
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      let actualAns = assetLogObj.actualAnswer.map((val) => {
        return unicodeToString(val).match(/[a-zA-Z_0-9-$-'-’-]+|[^\s\w]+/g);
      });
      setUserAnswer(actualAns);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const updateUserAnswer = (word) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      newArray[currentOptionIndex] = [...newArray[currentOptionIndex], word];
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  const removeFromActualContent = (innerIndex) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      let innerArray = [...newArray[currentOptionIndex]];
      innerArray.splice(innerIndex, 1);
      newArray[currentOptionIndex] = innerArray;
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <>
      {props.content && (
        <>
          <Box>
            <Grid
              container
              sx={{ flexDirection: "row", justifyContent: "flex-start", mt: 1 }}
            >
              {words &&
                words.length > 0 &&
                words.map((val, ind) => {
                  return (
                    <Grid
                      item
                      sx={{ ml: 1, my: 1, cursor: "pointer" }}
                      onClick={() => updateUserAnswer(val.trim())}
                    >
                      <Item
                        sx={{
                          lineHeight: 1,
                          border: 1,
                          borderColor: "#D9D9D9",
                          color: "primary.main",
                          fontWeight: "700",
                          fontSize: "0.9rem",
                          borderRadius: 10,
                          boxShadow: 0,
                          width: "5rem",
                          cursor: "pointer",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.2rem",
                            width: "8rem",
                            height: "1.4rem",
                          },
                        }}
                      >
                        {val.trim()}
                      </Item>
                    </Grid>
                  );
                })}
            </Grid>
          </Box>
          <Box sx={{ mt: 3 }}>
            <div  >
              {props.content.epage.options.content &&
                props.content.epage.options.content.map((val, index1) => {
                  return (
                    <>
                      <List dense sx={{ padding: 0, my: 2 }}>
                        <ListItem
                          sx={{
                            pa: 0,
                            paddingTop: "0px",
                            paddingBottom: "0px",
                          }}
                          onClick={() => {
                            setCurrentOptionIndex(index1);
                          }}
                        >
                          {optionWiseAns && optionWiseAns.length > 0 && (
                            <ListItemIcon>
                              <StatusIndicator
                                correct={optionWiseAns[index1]}
                              ></StatusIndicator>
                            </ListItemIcon>
                          )}
                          {val && val.media && (
                            <OptionMedia
                              media={val.media}
                              isPlaying={currentIndexPlay[index1]}
                              setPlayMode={(status, end) => {
                                setPlayMode(status, index1, end);
                              }}
                            ></OptionMedia>
                          )}
                          <ListItemText
                            classes={{ primary: classes.ListItemText }}
                            sx={{
                              pl: 1,
                              paddingTop: "2px",
                              paddingBottom: "2px",
                            }}
                          >
                            <Box>
                              <Grid container sx={{ flexDirection: "row" }}>
                                <Grid
                                  item
                                  className={classes.scrollBarHeight}
                                  xs={12}
                                  sx={{
                                    display: "flex",
                                    overflowY: "auto",
                                    paddingBottom: 1,
                                    borderBottom: 1,
                                    borderBottomColor:
                                      +index1 == +currentOptionIndex
                                        ? "#DB8829"
                                        : "#A9A9A9",
                                    mx: 1,
                                    mb: 1,
                                    height: "7vh",
                                    "@media (min-width: 1636px)": {
                                      width: "8rem",
                                    },
                                  }}
                                >
                                  {userAnswer[index1] &&
                                    userAnswer[index1].map(
                                      (val, innerIndex) => {
                                        return (
                                          <Box
                                            sx={{
                                              border: 1,
                                              borderColor: "#D9D9D9",
                                              color: "primary.main",
                                              fontWeight: "700",
                                              fontSize: "0.9rem",
                                              borderRadius: 10,
                                              boxShadow: 0,
                                              width: "auto",
                                              cursor: "pointer",
                                              padding: 1,
                                              marginX: 0.5,
                                              textAlign: "center",
                                              display: "flex",
                                              justifyContent: "space-around",
                                              alignItems: "center",
                                              "@media (min-width: 1636px)": {
                                                fontSize: "1.2rem",
                                                width: "auto",
                                              },
                                            }}
                                          >
                                            <span>{val}</span>
                                            <IconButton
                                              edge="end"
                                              au6ria-label="comments"
                                              sx={{
                                                color: "#A9A9A9",
                                                textAlign: "right",
                                              }}
                                              onClick={() =>
                                                removeFromActualContent(
                                                  innerIndex
                                                )
                                              }
                                            >
                                              <HighlightOffIcon
                                                sx={{
                                                  fontSize: "1rem",
                                                  "@media (min-width: 1636px)":
                                                    {
                                                      fontSize: "1.4rem",
                                                    },
                                                }}
                                              />
                                            </IconButton>
                                          </Box>
                                        );
                                      }
                                    )}
                                </Grid>
                              </Grid>
                            </Box>
                          </ListItemText>
                        </ListItem>
                      </List>
                    </>
                  );
                })}
            </div>
          </Box>
        </>
      )}
    </>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "62vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.3em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default SF;
